import {inject, Injectable} from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {APIService} from "./api.service";
import {IEmailAuditFilter} from "../interfaces/email-audit/IEmailAuditFilter";
import {IEmailAuditPagedResponse} from "../interfaces/email-audit/IEmailAuditPagedResponse";
import {IEmailAuditDetail} from "../interfaces/email-audit/IEmailAuditDetail";

@Injectable({
  providedIn: 'root'
})
export class EmailAuditService {
  private apiService = inject(APIService);

  getEmailAudits(filterP: IEmailAuditFilter) {
    let query_params = new HttpParams()
      .append("pageNumber", filterP.pageNumber)
      .append("pageSize", filterP.pageSize);

    if (filterP.playerId) {
      query_params = query_params.append("playerId", filterP.playerId);
    }

    if (filterP.gameId) {
      query_params = query_params.append("gameId", filterP.gameId);
    }

    if (filterP.includePlatformEmails) {
      query_params = query_params.append("includePlatformEmails", true);
    }

    if (filterP.platformEmailsOnly) {
      query_params = query_params.append("platformEmailsOnly", true);
    }

    if (filterP.recipient?.trim()) {
      query_params = query_params.append("recipient", filterP.recipient.trim());
    }

    if (filterP.emailTemplateTypeId) {
      query_params = query_params.append("emailTemplateTypeId", filterP.emailTemplateTypeId);
    }

    if (filterP.emailAuditStatusTypeId) {
      query_params = query_params.append("emailAuditStatusTypeId", filterP.emailAuditStatusTypeId);
    }

    // Whole days in the admin's time zone: from the start of the first day to the start of the day after the last, which the API treats as exclusive.
    if (filterP.fromDate) {
      const start_of_day = new Date(filterP.fromDate.getFullYear(), filterP.fromDate.getMonth(), filterP.fromDate.getDate());
      query_params = query_params.append("fromDate", start_of_day.toISOString());
    }

    if (filterP.toDate) {
      const day_after = new Date(filterP.toDate.getFullYear(), filterP.toDate.getMonth(), filterP.toDate.getDate() + 1);
      query_params = query_params.append("toDate", day_after.toISOString());
    }

    return this.apiService.MakeGetRequest<IEmailAuditPagedResponse>("email-audits", query_params);
  }

  getEmailAudit(emailAuditIdP: string) {
    return this.apiService.MakeGetRequest<IEmailAuditDetail>(`email-audits/${emailAuditIdP}`);
  }
}
